import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { uniqPrimativeMerge } from '../../utils/arrayUtils';
import { CartsActionKeys as keys } from './cartsActionKeys';
import { CartsActionTypes } from './cartsActionTypes';
import { ICartLine } from './cartsInterfaces';
import { getCartLineKey } from './cartsSelectors';

export interface ICartsState {
  carts: { [index: number]: { cartId: number; cartLines: number[] } };
  cartLines: { [index: number]: ICartLine };
  savingCartLines: string[];
}

const initState: ICartsState = {
  cartLines: {},
  carts: {},
  savingCartLines: []
};

export function cartsReducer(state: ICartsState = initState, action: CartsActionTypes): ICartsState {
  switch (action.type) {
    case keys.SET_CART:
      return {
        ...state,
        cartLines: {
          ...state.cartLines,
          ...keyBy(action.payload.cartLines, (x: ICartLine) => x.cartLineId)
        },
        carts: {
          ...state.carts,
          [action.payload.cartId]: {
            cartId: action.payload.cartId,
            cartLines: action.payload.cartLines.map(x => x.cartLineId)
          }
        }
      };
    case keys.SET_UPDATED_CART_LINE:
      return {
        ...state,
        cartLines: {
          ...omit(state.cartLines, action.payload.removedLineIds),
          ...keyBy(action.payload.cartLines, (x: ICartLine) => x.cartLineId)
        },
        carts: {
          ...state.carts,
          [action.payload.cartId]: {
            ...state.carts[action.payload.cartId],
            cartLines: uniqPrimativeMerge(
              state.carts[action.payload.cartId].cartLines.filter(x => !action.payload.removedLineIds.includes(x)),
              action.payload.cartLines.map(x => x.cartLineId)
            )
          }
        }
      };
    case keys.TOGGLE_SAVING_CART_LINE:
      const key = getCartLineKey(action.payload);
      return {
        ...state,
        savingCartLines: state.savingCartLines.includes(key)
          ? state.savingCartLines.filter(x => x !== key)
          : [...state.savingCartLines, key]
      };
    case keys.UPDATE_CART_LINES:
      return {
        ...state,
        cartLines: {
          ...state.cartLines,
          ...keyBy(action.payload, (x: ICartLine) => x.cartLineId)
        }
      };
    default:
      return state;
  }
}
